export default __webpack_public_path__ + "static/media/br.7d241dc1.svg";